import React, { useEffect, useRef, useState } from "react";
import EvaluatorLayout from "../../../components/evaluator-layout";
import styled from "styled-components";
import LoadingModal from "../../../components/loading-modal";
import { MenuItem, Select, Tab, Tabs } from "@mui/material";
import dayjs from "dayjs";
import IconMedalGold from "../../../assets/images/icon-medal-gold.svg";
import IconMedalSilver from "../../../assets/images/icon-medal-silver.svg";
import IconMedalCopper from "../../../assets/images/icon-medal-copper.svg";
import { BarChart } from '@mui/x-charts/BarChart';
import { useSearchParams } from "react-router-dom";
import { onSleep, onLoginLineLiff } from "../../../utils/default";
import CoreAPI from "../../../services/core";

const Container = styled.div`
    width: 100%;
`;

const Banner = styled.div`
    width: calc(100% - 32px);
    height: 100px;
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    padding-left: 32px;

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 600;
        line-height: 28.88px;
        text-align: left;
    }

`;

const Body = styled.div`
    width: 100%;
    height: calc(100% - 100px);
    padding: 24px 0px;
    display: flex;
    flex-direction: column;

    .description {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 8px;
    }
    .title {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 12px;
    }
`;

const TabsStyle = styled(Tabs)({
    "& .MuiTabs-indicator": {
        backgroundColor: "#FBE250",
        height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
        color: '#25368D',
        fontSize: '16px',
        fontWeight: '600',
    },
    "& .MuiTab-root": {
        fontSize: '16px',
    },
});

const TabBox = styled.div`
    width: 100%;
    height: 40px;
`;

const TabBody = styled.div`
    width: calc(100% - 48px);
    padding: 16px 24px 0px 24px;
    margin-top: 8px;

    .filter-bar {
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
    }

    .chart-box {

    }

    .medal-box {
        .no-data-label {
            color: #505050;
            font-size: 15px;
            font-weight: 300;
            margin-top: 24px;
        }
    }
`;

const MedalCard = styled.div`
    width: calc(100% - 32px);
    min-height: 75px;
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    padding: 8px 16px;

    .label-location-box {
        width: calc(100% - 120px);
        margin-left: 16px;
    }
    
    .label-name {
        overflow-wrap: anywhere;
        color: #25368D;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }
    .label-location {
        overflow-wrap: anywhere;
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
    }
    .label-amount-box {
        width: 64px;
        padding-left: 8px;

        .label-title-amount {
            color: #505050;
            font-size: 10px;
            font-weight: 300;
        }
    }
    .label-amount {
        color: #25368D;
        font-size: 15px;
        font-weight: 600;
        line-height: 22.43px;
        text-align: left;
    }
`;

const chartSetting = {
    series: [
        {
            dataKey: 'service_amount',
            label: 'ใช้บริการ',
            color: "#FBE250",
        },
        {
            dataKey: 'survey_amount',
            label: 'ตอบแบบสอบถาม',
            color: "#25368D",
        },
    ],
    height: 300,
    sx: {},
    slotProps: {
        legend: { hidden: false },
        bar: {
            clipPath: "inset(0px round 8px 8px 0px 0px)",
        }
    },
    barLabel: "value"
};

function EvaluatorEvaluatorHistoryPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchParamsRef = useRef({
        evaluator_id: null,
        line_user_id: null,
    })
    const [isLoading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [selectYear, setSelectYear] = useState({
        label: dayjs().format("BBBB"),
        value: Number(dayjs().format("BBBB")),
    });
    const [listYear, setListYear] = useState([]);
    const [selectType, setSelectType] = useState("แบบสอบถามภาพรวม");
    const [listType, setListType] = useState([]);
    const [listMedal, setListMedal] = useState([]);
    const [dataSet, setDataSet] = useState([]);
    const [evaluatorProfile, setEvaluatorProfile] = useState(null)

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        const liffResponse = await onLoginLineLiff(window.location.href);

        let evaluator = null;
        // 1. Prioritize LIFF User
        if (liffResponse?.profile?.userId) {
            evaluator = await onGetEvaluatorByLineUserId(liffResponse.profile.userId);
            if (evaluator?.evaluator_id) {
                const newParams = new URLSearchParams(searchParams);
                newParams.set("evaluator_id", evaluator.evaluator_id);
                newParams.set("line_user_id", liffResponse.profile.userId);
                setSearchParams(newParams);

                // Update ref for consistency in this render cycle if needed elsewhere
                searchParamsRef.current.evaluator_id = evaluator.evaluator_id;
                searchParamsRef.current.line_user_id = liffResponse.profile.userId;
            }
        }

        // 2. Fallback to URL Params (only if no LIFF user found / not logged in)
        if (!evaluator) {
            searchParamsRef.current.evaluator_id = searchParams.get("evaluator_id");
            searchParamsRef.current.line_user_id = searchParams.get("line_user_id");

            if (searchParamsRef.current.evaluator_id) {
                evaluator = await onGetEvaluatorById(searchParamsRef.current.evaluator_id);
            } else if (searchParamsRef.current.line_user_id) {
                evaluator = await onGetEvaluatorByLineUserId(searchParamsRef.current.line_user_id);
            }
        }

        const _listYear = await onGetListYear();
        await onGetListType();
        await onGetListMedal(_listYear, selectYear);
        await onGetChartValue(_listYear, selectYear);
        await onSleep(500);
        setIsLoading(false);
    }
    async function onGetEvaluatorById(param) {
        let response = null;
        let _detail;
        try {
            response = await CoreAPI.satHttpService.getEvaluatorById(param);
        } catch { }
        if (response) {
            _detail = {
                ...response,
                birthdate: new Date(response.birthdate)
            }
        }
        setEvaluatorProfile(_detail)
        return _detail;
    }
    async function onGetEvaluatorByLineUserId(id) {
        let response = null;
        let _detail;
        try {
            let body = {
                line_user_id: id,
            }
            response = await CoreAPI.satHttpService.upsertEvaluatorByLineUserIdDto(body);
        } catch { }
        if (response) {
            _detail = {
                ...response,
                birthdate: new Date(response.birthdate)
            }
        }
        setEvaluatorProfile(_detail)
        return _detail;
    }
    async function onUpdateEvaluator(param) {
        let response = null;
        try {
            let body = {
                evaluator_id: searchParamsRef.current.evaluator_id,
                ...param,
            }
            response = await CoreAPI.satHttpService.updateEvaluatorProfile(body);
        } catch { }
        return response;
    }
    async function onGetListYear() {
        let _list = [];
        for (let i = 0; i < 100; i++) {
            const date = dayjs().startOf('date');
            const year = dayjs(date).subtract(i, 'year');
            const label = dayjs(year).format("BBBB")
            let detail = {
                dayjs: year,
                label: label,
                value: Number(label),
            }
            _list.push(detail)
        }
        setListYear(_list)
        return _list;
    }
    async function onGetListType() {
        let list = [
            {
                label: "แบบสอบถามภาพรวม",
                value: "แบบสอบถามภาพรวม",
            },
        ];
        let response = null;
        try {
            let body = {
                evaluator_id: searchParamsRef.current.evaluator_id,
            }
            response = await CoreAPI.satHttpService.getEvaluationFormEvaluatorServiceHistoryByEvaluatorId(body);
        } catch { }
        if (response) {
            let _list = JSON.parse(JSON.stringify(response))
            for (let item of _list) {
                let detail = {
                    label: item.evaluation_form_evaluation_data?.title,
                    value: item.evaluation_form_evaluation_form_id,
                }
                if (item.evaluation_form_evaluation_type === "Place") {
                    detail.label = item.location_location_name
                }
                list.push(detail)
            }
        }
        setListType(list)
    }
    async function onGetListMedal(_listYear, _selectYear) {
        let _list = [];
        let response = null;
        try {
            let body = {
                evaluator_id: searchParamsRef.current.evaluator_id,
                rank: 3,
            }
            response = await CoreAPI.satHttpService.getEvaluatorServiceHistoryLocationByParam(body);
        } catch { }
        if (response) {
            _list = JSON.parse(JSON.stringify(response))
            _list = _list.map((value, index) => {
                let medal = null;
                if (index === 0) {
                    medal = IconMedalGold;
                } else if (index === 1) {
                    medal = IconMedalSilver;
                } else if (index === 2) {
                    medal = IconMedalCopper;
                }
                let province = value.location_province;
                if (province === "กรุงเทพฯ") {
                    province = "กรุงเทพมหานคร";
                }
                let detail = {
                    id: value.location_location_id,
                    medal: medal,
                    name: value.location_location_name,
                    province: province,
                    provinceLabel: `จังหวัด ${province}`,
                    amout: Number(value.count),
                    amoutLabel: `${value.count} ครั้ง`,
                    amoutSurvey: Number(value.count_survey),
                    amoutLabelSurvey: `${value.count_survey} ครั้ง`,
                }
                return detail;
            })
        }
        setListMedal(_list)
    }
    async function onGetChartValue(_listYear, _selectYear, evaluation_form_id) {
        let listMonth = [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
        ];
        let list = []
        let response = null;
        try {
            let modelYear = _listYear.find(x => x.value === _selectYear.value);
            const start_date = dayjs(modelYear?.dayjs.toDate()).startOf('year')
            const end_date = dayjs(modelYear?.dayjs.toDate()).endOf('year')
            let body = {
                evaluation_form_id: evaluation_form_id,
                evaluator_id: searchParamsRef.current.evaluator_id,
                start_date: start_date.toDate(),
                end_date: end_date.toDate(),
                type: "year",
            }
            response = await CoreAPI.satHttpService.getDashboardFrequencyEvaluatorServiceHistoryByParam(body);
        } catch { }
        if (response) {
            for (let i = 0; i < 12; i++) {
                let detail = {
                    service_amount: response.service[i].amount,
                    survey_amount: response.survey[i].amount,
                    title: listMonth[i],
                }
                list.push(detail)
            }
        }
        setDataSet(list)
    }
    // ========== ========== ========== ==========
    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }
    async function handleChangeYear(param) {
        setIsLoading(true);
        const value = param.target.value;
        let detail = {
            label: value,
            value: Number(value),
        }
        setSelectYear(detail)
        let id = selectType;
        if (id === "แบบสอบถามภาพรวม") {
            id = null;
        }
        await onGetChartValue(listYear, detail, id);
        await onSleep(500);
        setIsLoading(false);
    }
    async function handleChangeType(param) {
        setIsLoading(true);
        const value = param.target.value
        setSelectType(value)
        let id = value;
        if (id === "แบบสอบถามภาพรวม") {
            id = null;
        }
        await onGetChartValue(listYear, selectYear, id);
        await onSleep(500);
        setIsLoading(false);
    }

    return (
        <EvaluatorLayout showBack={false}>
            <Container>
                <Banner className="vertical-center">
                    <div className="label">ประวัติ/สถิติ จำนวนการมาใช้บริการ<br />และการตอบแบบสอบถามฯ</div>
                </Banner>
                <Body>
                    <TabBox>
                        <TabsStyle
                            value={tabValue}
                            onChange={handleChangeTab}>
                            <Tab label="ประวัติ" style={{ width: "50%" }} />
                            <Tab label="3 อันดับยอดนิยม" style={{ width: "50%" }} />
                        </TabsStyle>
                    </TabBox>
                    <TabBody>
                        {tabValue === 0 ?
                            <>
                                <div className="filter-bar">
                                    <Select
                                        value={selectYear?.value}
                                        onChange={handleChangeYear}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                                        sx={{
                                            '& .MuiSelect-select': {
                                                paddingRight: 4,
                                                paddingLeft: 0,
                                                paddingTop: 1,
                                                paddingBottom: 1,
                                            },
                                            '.MuiOutlinedInput-notchedOutline': {
                                                border: "none"
                                            },
                                            color: "#243465",
                                            fontSize: "18px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {listYear.map((value, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={value.value}
                                                    sx={{
                                                        color: "#243465",
                                                        fontSize: "16px",
                                                        fontWeight: "400",
                                                    }}
                                                >
                                                    ปี {value.label}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                    <Select
                                        value={selectType}
                                        onChange={handleChangeType}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                                        sx={{
                                            '& .MuiSelect-select': {
                                                paddingRight: 0,
                                                paddingLeft: 0,
                                                paddingTop: 1,
                                                paddingBottom: 1,
                                            },
                                            '.MuiOutlinedInput-notchedOutline': {
                                                border: "none"
                                            },
                                            color: "#505050",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            maxWidth: "200px",
                                        }}
                                    >
                                        {listType.map((value, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={value.value}
                                                    title={`${value.label}`}
                                                    sx={{
                                                        color: "#505050",
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        whiteSpace: "pre-line",
                                                    }}
                                                >
                                                    {value.label}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </div>
                                <div className="chart-box">
                                    <BarChart
                                        dataset={dataSet}
                                        xAxis={[
                                            {
                                                scaleType: 'band',
                                                dataKey: 'title',
                                                tickPlacement: 'start',
                                                tickLabelPlacement: 'middle',
                                            },
                                        ]}
                                        yAxis={[{
                                            valueFormatter: (value) => `${value}`,
                                            max: 10,
                                            min: 0,
                                        }]}
                                        {...chartSetting}
                                    />
                                </div>
                            </>
                            :
                            <>
                                <div className="filter-bar">
                                </div>
                                <div className="medal-box">
                                    {listMedal.map((value, index) => {
                                        return (
                                            <MedalCard key={index} className="vertical-center">
                                                <img alt="img" src={value.medal} />
                                                <div className="label-location-box">
                                                    <div className="label-name">{value.name}</div>
                                                    <div className="label-location">{value.provinceLabel}</div>
                                                </div>
                                                <div className="label-amount-box">
                                                    <div className="label-title-amount">ใช้บริการ</div>
                                                    <div className="label-amount">{value.amoutLabel}</div>
                                                    <div className="label-title-amount">แบบสอบถาม</div>
                                                    <div className="label-amount">{value.amoutLabelSurvey}</div>
                                                </div>
                                            </MedalCard>
                                        )
                                    })}
                                    {listMedal.length === 0 && <div className="content-center no-data-label">ไม่มีข้อมูล</div>}
                                </div>
                            </>
                        }

                    </TabBody>
                </Body>
            </Container>
            <LoadingModal open={isLoading} />
        </EvaluatorLayout>
    )
}

export default EvaluatorEvaluatorHistoryPage;